import { useState, useEffect, useCallback } from 'react';
import { hrms } from '../../services/api';
import Card from '../../components/common/Card';
import Badge from '../../components/common/Badge';
import Table from '../../components/common/Table';
import { theme } from '../../theme';

function WFHManagement() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterStatus, setFilterStatus] = useState('');

  const fetchRequests = useCallback(async () => {
    setLoading(true);
    try {
      const params = {};
      if (filterStatus) params.status = filterStatus;
      const r = await hrms.getWFHRequests(params);
      const d = r.data;
      setRequests(Array.isArray(d) ? d : d.items || []);
    } catch { setRequests([]); }
    finally { setLoading(false); }
  }, [filterStatus]);

  useEffect(() => { fetchRequests(); }, [fetchRequests]);

  const columns = [
    { header: 'Employee', key: 'employee_name', render: (v) => v || '—' },
    { header: 'Emp Code', key: 'emp_code',       render: (v) => v ? <span style={{ fontFamily: 'monospace', fontSize: '0.8rem' }}>{v}</span> : '—' },
    { header: 'WFH Date', key: 'date',           render: (v) => v ? new Date(v).toLocaleDateString('en-IN') : '—' },
    { header: 'Reason',   key: 'reason',         render: (v) => v ? (v.length > 60 ? v.substring(0, 60) + '...' : v) : '—' },
    { header: 'Status',   key: 'status',         render: (v, row) => <Badge status={v} byName={row.approved_by_name || row.pending_approver_name} /> },
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
        <div>
          <h1 style={{ fontSize: '1.5rem', fontWeight: 700, color: theme.text, margin: 0 }}>WFH Management</h1>
          <p style={{ color: theme.textMuted, fontSize: '0.875rem', margin: '0.25rem 0 0' }}>Manage Work From Home requests</p>
        </div>
        <select value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}
          style={{ padding: '0.5rem 0.875rem', border: `1.5px solid ${theme.border}`, borderRadius: '0.5rem', fontSize: '0.875rem', color: theme.text, outline: 'none' }}>
          <option value="">All Status</option>
          <option value="pending">Pending</option>
          <option value="approved">Approved</option>
          <option value="rejected">Rejected</option>
        </select>
      </div>

      <Card padding="0">
        <Table columns={columns} data={requests} loading={loading} emptyMessage="No WFH requests found" />
      </Card>
    </div>
  );
}

export default WFHManagement;
